/**
 * Mensagem do servidor a partir do erro do `apiRequest` ("409: {json}").
 *
 * O `apiRequest` lança `Error("<status>: <corpo>")`; o corpo das rotas do
 * Equipe é sempre `{ error, code? }`. Aqui se extrai `error` (e `code`) para o
 * toast mostrar a frase REAL — o genérico "Erro ao salvar" escondia justamente
 * os 409 que dizem o que precisa ser resolvido antes.
 */
export function msgDoErro(e: unknown, fallback: string): string {
  const bruto = String((e as any)?.message ?? "");
  try {
    const j = JSON.parse(bruto.slice(bruto.indexOf(":") + 1).trim());
    if (typeof j?.error === "string") return j.error;
  } catch {
    // Corpo não-JSON: cai no fallback. Nunca engolir o erro em silêncio.
  }
  return fallback;
}

/** `code` do corpo do erro (`ADIANTAMENTO_PENDENTE`, `FECHAMENTO_FECHADO`…), ou null. */
export function codigoDoErro(e: unknown): string | null {
  const bruto = String((e as any)?.message ?? "");
  try {
    const j = JSON.parse(bruto.slice(bruto.indexOf(":") + 1).trim());
    return typeof j?.code === "string" ? j.code : null;
  } catch {
    return null;
  }
}
